/* Team K9 slide cart d1 (design B, one-tap checklist). Markup and offer rules: sections/tk9-cart-drawer.liquid.
   The theme's cart type stays "page". This script only takes over when it is on, not killed, in the "offers" arm and
   not on /cart; otherwise it does nothing at all and every add goes to /cart exactly as on the live site.
   How an add opens the drawer (one handler per add, never two):
     - product pages (Horizon product-form-component): the script sets html[data-cart-type=drawer], so the theme's own
       product form adds as usual and skips its redirect; its cart:update event (sent only after a successful add)
       opens the drawer once the server cart shows the line. If that cannot be confirmed, it goes to /cart.
     - landers (native {% form 'product' %}): a document-level submit listener runs after the lander's own guards
       (size, patch text, sold out); if the submit is still going ahead it is replaced by one /cart/add.js call. On any
       error the form is submitted natively, i.e. to /cart as today.
   Kill switch: ?tk9_cart_off=1 (sticks; ?tk9_cart_on=1 undoes), localStorage tk9_cart_off=1, TK9Cart.disable(), or the
   section's "Slide cart on" setting. Arm: tk9_arm cookie + localStorage ('offers' | 'holdout', 30 days), written to the
   cart as _tk9_arm with _tk9_cart_v so both land on the order. Holdout = no drawer (/cart as today).
   Events: dataLayer + document 'tk9:cart' + Shopify.analytics.publish('tk9_cart_<name>'). */
(function () {
  if (window.TK9Cart) return;
  var el = document.getElementById('Tk9Cart');
  if (!el) return;
  var V = el.dataset.version || 'd1', SECTION = el.dataset.section || 'tk9-cart-drawer';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  };
  var qs = new URLSearchParams(location.search);
  if (qs.get('tk9_cart_off') === '1') store.set('tk9_cart_off', '1');
  if (qs.get('tk9_cart_on') === '1') store.set('tk9_cart_off', null);
  // off: setting, sticky URL kill, or this page's template family switched off in "Pages it runs on"
  var killed = el.dataset.enabled !== 'true' || el.dataset.scope === 'false' || store.get('tk9_cart_off') === '1';

  // the arm is chosen before paint by the section's inline script (window.__tk9Arm); this is the same rule as a fallback
  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  // arm: "lander" (first page a lander: drawer everywhere), "offers" / "holdout" (first page a hero product page, split
  // by the holdout share). Chosen and stored before paint (tk9_arm2); without it (family switched off) nothing runs.
  var arm = window.__tk9Arm || 'lander', fresh = !!window.__tk9ArmFresh, family = window.__tk9Family || el.dataset.family || 'lander';

  function emit(name, data) {
    var p = { event: 'tk9_cart_' + name, tk9_cart_v: V, tk9_arm: arm };
    for (var k in data || {}) p[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tk9:cart', { detail: p })); } catch (e) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('tk9_cart_' + name, p); } catch (e) {}
  }
  // Merchanting Watch. Root tk9.cart.drawer (declared, never repainted): open = drawer opened, change = an add-on or
  // nudge taken from the drawer, complete = Secure checkout clicked (click = any tap inside, counted by Watch itself).
  // Parts (tk9.cart.offer.*, .nudge.*, .line, .checkout ...): open = shown in an open drawer, click = added/tapped,
  // change = removed or quantity changed. Rows are rebuilt on repaint, so they report here instead of via watch-kind.
  var wSeen = {};
  function wroot(action) {
    try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: 'cart', action: action, component_id: 'tk9.cart.drawer' }); } catch (e) {}
  }
  function wt(node, action) {
    var id = node && node.getAttribute && node.getAttribute('data-watch-component'), kind = node && node.getAttribute('data-kcd-wk');
    if (!id || !kind) return;
    try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: kind, action: action, component_id: id }); } catch (e) {}
  }
  function onCartPage() { return /^\/cart\/?$/.test(location.pathname); }
  function active() { return !killed && arm !== 'holdout' && !onCartPage(); }
  if (fresh && !killed) emit('arm', { assigned: arm, family: family });
  // Watch: during the 50/50 (holdout share > 0) hero product pages declare the arm (html data-watch-experiment / -variant,
  // set before paint); this repeats it through the API once Watch has loaded. At 0% (full-time since 2026-10-18 16:47
  // UTC) nothing is declared, so a page test (e.g. the tk9-bb-* buy-box tests) owns the visit's one experiment.
  if (!killed && family === 'pdp' && arm !== 'lander' && Number(el.dataset.holdout || 0) > 0 && document.documentElement.getAttribute('data-watch-experiment') === 'tk9-cart-pdp-d1') [3000, 9000].forEach(function (t) { setTimeout(function () { try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('experiment_exposed', { experiment_id: 'tk9-cart-pdp-d1', variant_id: arm, page_version_id: 'tk9-cart-pdp-d1:' + arm }); } catch (e) {} }, t); });

  // The arm rides on the cart (both arms) so it lands on the order. XHR, not fetch: the layout's fetch wrapper would
  // flash the /cart subtotal for a background write.
  function writeArm(done) {
    try {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/update.js');
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onloadend = function () { if (done) done(); };
      x.send(JSON.stringify({ attributes: { _tk9_arm: arm, _tk9_cart_v: V } }));
    } catch (e) { if (done) done(); }
  }
  if (!killed && Number(el.dataset.count || 0) > 0 && el.dataset.arm !== arm) writeArm();

  var busy = false, lastFocus = null, opened = false;
  function inner() { return el.querySelector('#Tk9CartInner'); }
  function msg(t) { var m = el.querySelector('[data-kcd-msg]'); if (m) m.textContent = t || ''; }
  // dollars in a USD cart (as before); another currency shows its code, so a CAD or GBP price never reads as USD
  function money(c) {
    var cur = (inner() && inner().dataset.currency) || 'USD';
    if (cur !== 'USD') try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: 'code' }).format(Number(c || 0) / 100); } catch (e) {}
    return '$' + (Number(c || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function post(url, body) {
    body.sections = SECTION;
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function pickEl(html, sel) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null; }
  function paint(j) {
    var s = (j && j.sections) || {};
    var next = pickEl(s[SECTION], '#Tk9CartInner');
    if (next) {
      var cur = inner(), scroller = el.querySelector('[data-kcd-scroll]'), top = scroller ? scroller.scrollTop : 0;
      var added = el.querySelector('[data-kcd-added]'), addedText = added && !added.hidden ? added.textContent : '';
      Array.prototype.forEach.call(next.attributes, function (a) { if (a.name.indexOf('data-') === 0) cur.setAttribute(a.name, a.value); });
      cur.innerHTML = next.innerHTML;
      var sc = el.querySelector('[data-kcd-scroll]'); if (sc) sc.scrollTop = top;
      if (addedText) showAdded(addedText);
      el.dataset.count = cur.dataset.count;
    }
    bubble();
    upgrades();
    seen();
  }
  // the header bubble follows the cart (Horizon's cart-icon reads detail.data.itemCount from cart:update)
  function bubble() {
    var i = inner(); if (!i) return;
    try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'tk9-cart', data: { source: 'tk9-cart-drawer', itemCount: Number(i.dataset.count || 0) } } })); } catch (e) {}
  }
  function showAdded(t) { var a = el.querySelector('[data-kcd-added]'); if (!a) return; a.textContent = t; a.hidden = !t; }
  // one request on open: keeps the arm and version on the cart and returns the fresh drawer
  function refresh() { return post('/cart/update.js', { attributes: { _tk9_arm: arm, _tk9_cart_v: V } }).then(paint); }

  function show() {
    el.hidden = false;
    document.documentElement.classList.add('kcd-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    var x = el.querySelector('.kcd-x'); if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    if (!opened) return;
    opened = false;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('kcd-lock');
    setTimeout(function () { if (!opened) el.hidden = true; }, 260);
    showAdded('');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    emit('close', {});
  }
  function open(opts) {
    if (!active()) return false;
    opts = opts || {};
    if (!opened) lastFocus = document.activeElement;
    opened = true;
    el.classList.add('is-loading');
    show();
    showAdded(opts.added || '');
    var p = opts.painted ? Promise.resolve(paint(opts.painted)) : refresh();
    p.catch(function () {}).then(function () {
      el.classList.remove('is-loading');
      var i = inner();
      wroot('open');
      emit('open', { source: opts.source || 'other', items: Number(i && i.dataset.count || 0), value: Number(i && i.dataset.total || 0) / 100, rows: Number(i && i.dataset.rows || 0) });
    });
    return true;
  }
  function toCart(reason) {
    emit('fallback', { reason: reason });
    document.body.classList.add('cart-redirecting');
    window.location.href = '/cart';
  }

  /* ---------------- add-to-cart takeover ---------------- */
  // product pages: the theme's product form does the add; this only stops its redirect and opens the drawer after it
  var pending = null; // { btn, variant, before, t }
  function setBusy(btn, on) { if (btn) btn.classList.toggle('kcd-adding', !!on); }
  function units(cart, variant) { var n = 0; (cart.items || []).forEach(function (i) { if (String(i.variant_id) === String(variant)) n += i.quantity; }); return n; }
  // the server cart must show the variant with at least the expected units (retries while Shopify settles)
  function confirm(variant, minUnits, tries) {
    return getCart().then(function (c) {
      if (units(c, variant) >= minUnits) return c;
      if (tries > 0) return new Promise(function (r) { setTimeout(r, 400); }).then(function () { return confirm(variant, minUnits, tries - 1); });
      throw new Error('not in cart');
    });
  }
  function nameOf(c, variant) { var it = (c.items || []).filter(function (i) { return String(i.variant_id) === String(variant); })[0]; return it ? it.product_title.replace(/^NEW\s+/, '').replace(/Team K9®?\s*/, '').split(' (')[0].split(' With ')[0].split(' with ')[0] : ''; }
  // units per variant as the server rendered them (page load, then every repaint): the "before" of an add, race-free
  function knownUnits(variant) { var m = {}; try { m = JSON.parse((inner() && inner().dataset.units) || '{}'); } catch (e) {} return Number(m[String(variant)] || 0); }
  // one request: writes the arm, returns the cart (to check the add) and the fresh drawer; retries while Shopify settles
  function afterAdd(variant, want, btn, source) {
    function done(j) {
      setBusy(btn, false);
      // the fresh drawer must show this cart; if the re-render came back without it, /cart (server truth) instead
      var fresh = pickEl(((j && j.sections) || {})[SECTION], '#Tk9CartInner');
      if (!fresh || Number(fresh.getAttribute('data-count')) !== Number(j.item_count)) { toCart('render'); return; }
      emit('add_confirmed', { variant: Number(variant), source: source, units: units(j, variant) });
      open({ source: source, added: '✓ Added', painted: j });
      // the short name the drawer itself shows for that line
      var ln = el.querySelector('.kcd-line[data-variant="' + variant + '"] .kcd-name'), name = ln ? ln.textContent.trim() : nameOf(j, variant);
      if (name) showAdded('✓ Added: ' + name);
    }
    return post('/cart/update.js', { attributes: { _tk9_arm: arm, _tk9_cart_v: V } }).then(function (j) {
      if (units(j, variant) >= want) return done(j);
      return confirm(variant, want, 4).then(function () { return post('/cart/update.js', {}); }).then(done);
    }).catch(function () { setBusy(btn, false); toCart('unconfirmed'); });
  }
  // Candy Rack's product-page checkbox ("Customize It?", e.g. custom name patches under the harness): in today's flow
  // Candy Rack's main script adds the ticked items when Add to cart is pressed. That script is off in the drawer arm
  // (it also runs the popup), so the drawer adds them itself, exactly as Candy Rack posts them: the ticked variant,
  // quantity 1, the custom note as the line property "note". Read at the Add press; added right after the product.
  function pppItems() {
    var out = [], items = [];
    try { (JSON.parse((document.getElementById('candyrack-ppp-offers-data') || {}).textContent || '{}').offers_checkbox || []).forEach(function (o) { (o.items || []).forEach(function (it) { items.push(it); }); }); } catch (e) {}
    Array.prototype.forEach.call(document.querySelectorAll('.candyrack-ppp-checkbox-layout__offer'), function (o) {
      var cb = o.querySelector('input[type=checkbox]'); if (!cb || !cb.checked) return;
      var sel = o.querySelector('select.candyrack-ppp-select-input'), vid = sel && sel.value;
      if (!vid) { var m = /candyrack-ppp-product-id-(\d+)/.exec(o.className), it = m && items.filter(function (x) { return String(x.item_id) === m[1]; })[0]; vid = it && it.item_variants && it.item_variants[0]; }
      if (!vid) return;
      var note = o.querySelector('input.candyrack-ppp-text-input'), props = {};
      if (note && note.value.trim()) props.note = note.value.trim();
      out.push({ id: Number(vid), quantity: 1, properties: props, el: o });
    });
    return out;
  }
  // Page tests that add a second line with the product (e.g. the tk9-bb-* buy-box kit "Harness + custom name patch")
  // define window.TK9CartExtraItems(form) -> [{ id, quantity, properties }]. Read at the Add press, posted right after the
  // product's own add, before the drawer paints, so the drawer opens with both lines.
  function extraItems(form) {
    try {
      var f = window.TK9CartExtraItems, x = typeof f === 'function' ? f(form) : null;
      return Array.isArray(x) ? x.filter(function (i) { return i && i.id; }).map(function (i) { return { id: Number(i.id), quantity: Math.max(1, Number(i.quantity || 1)), properties: i.properties || {} }; }) : [];
    } catch (e) { return []; }
  }
  function addPpp(list) {
    if (!list || !list.length) return Promise.resolve();
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list.map(function (x) { return { id: x.id, quantity: x.quantity, properties: x.properties }; }) }) })
      .then(function (r) { if (!r.ok) throw new Error('ppp'); emit('ppp_add', { items: list.length }); list.forEach(function (x) { if (!x.el) return; var cb = x.el.querySelector('input[type=checkbox]'), box = x.el.querySelector('.candyrack-ppp--checkbox'); if (cb && cb.checked && box) box.click(); }); })
      .catch(function () { emit('error', { message: 'extra item add failed' }); });
  }
  // An Add that landed before this script had loaded (the section's inline script set the drawer cart mode and kept the
  // form): add any ticked extras the same way, then open the drawer (its refresh writes _tk9_arm / _tk9_cart_v).
  function earlyAdd() {
    var f = window.__tk9EarlyForm; window.__tk9Early = 0; window.__tk9EarlyForm = null;
    if (!active()) { toCart('inactive'); return; }
    var v = f ? formVariant(f) : null;
    addPpp(pppItems().concat(f ? extraItems(f) : [])).then(function () {
      if (v) emit('add_confirmed', { variant: Number(v), source: 'product_form_early', units: 0 });
      open({ source: 'product_form_early', added: '✓ Added' });
    });
  }
  function formVariant(form) { var i = form && form.querySelector('[name="id"]'); return i ? i.value : null; }
  function formQty(form) { var q = form && form.querySelector('[name="quantity"]'); return Math.max(1, Number(q && q.value || 1)); }

  // product-form-component submits: note the variant and the units before, so the cart:update can be checked
  document.addEventListener('submit', function (e) {
    if (!active()) return;
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form-component')) return;
    var v = formVariant(form); if (!v) return;
    var btn = form.querySelector('[type="submit"]');
    var p = pending = { btn: btn, variant: v, qty: formQty(form), before: knownUnits(v), t: Date.now(), ppp: pppItems().concat(extraItems(form)) };
    setBusy(btn, true);
    // the theme never reported back: let /cart (server truth) show what happened
    p.timer = setTimeout(function () { if (pending === p) { pending = null; setBusy(btn, false); toCart('no_event'); } }, 12000);
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    // a Dog Star piece added from inside the drawer (tk9-dog-more): redraw the drawer with it
    if (d.source === 'tk9-dog-more' && opened) { refresh().catch(function () {}); return; }
    if (d.source === 'product-form-component' && !pending && window.__tk9EarlyForm) { earlyAdd(); return; }
    if (d.source !== 'product-form-component' || !pending) return;
    var p = pending; pending = null; clearTimeout(p.timer);
    if (d.didError) { setBusy(p.btn, false); emit('error', { message: 'product form add error' }); return; }
    if (!active()) { toCart('inactive'); return; }
    addPpp(p.ppp).then(function () { afterAdd(p.variant, p.before + p.qty, p.btn, 'product_form'); });
  });

  // The product page's sticky "Add to Cart" bar (sections/sticky-add-to-cart.liquid) has its own form and script that
  // add and then go to /cart, which skipped the drawer (no add-ons, no _tk9_arm, ticked extras dropped) until
  // 2026-10-18. In the drawer arm its submit is handed to the page's main product form when that shows the same variant
  // (so its quantity, Kaching deal, buy-box kit and Candy Rack checkbox all come along), else added here from the bar's
  // own form. Capture phase, so the bar's own script never runs; the availability guard (registered earlier) still wins.
  document.addEventListener('submit', function (e) {
    if (!active() || e.defaultPrevented) return;
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('sticky-add-to-cart__form')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(form), v = fd.get('id');
    var main = document.querySelector('product-form-component form[action*="/cart/add"]');
    var mainBtn = main && main.querySelector('[type="submit"]');
    // on an options-app page (custom patch) the bar has no name field: an empty name is asked for, never added blank
    var need = main && Array.prototype.filter.call(main.querySelectorAll('[name^="properties["]'), function (i) { return (i.required || /Which text or name/.test(i.name)) && !String(i.value || '').trim(); })[0];
    if (need) { try { need.scrollIntoView({ block: 'center', behavior: 'smooth' }); need.focus({ preventScroll: true }); } catch (x) {} emit('sticky_add', { variant: Number(v), via: 'needs_name' }); return; }
    if (main && mainBtn && !mainBtn.disabled && String(formVariant(main)) === String(v)) {
      emit('sticky_add', { variant: Number(v), via: 'main_form' });
      if (typeof main.requestSubmit === 'function') main.requestSubmit(mainBtn); else mainBtn.click();
      return;
    }
    if (!v) { toCart('sticky_no_variant'); return; }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    var btn = form.querySelector('[type="submit"]'), q = Math.max(1, Number(fd.get('quantity') || 1)), extra = pppItems().concat(main ? extraItems(main) : []);
    setBusy(btn, true); emit('sticky_add', { variant: Number(v), via: 'bar_form' });
    getCart().then(function (c) {
      var before = units(c, v);
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'add failed'); return j; }); })
        .then(function () { return addPpp(extra); })
        .then(function () { return afterAdd(v, before + q, btn, 'sticky'); });
    }).catch(function (err) { setBusy(btn, false); emit('error', { message: 'sticky add: ' + String(err && err.message || '').slice(0, 80) }); toCart('sticky_error'); });
  }, true);

  // Pages whose name/phone fields belong to a product-options app that adds and then goes to /cart on its own
  // (setting "Pages where the drawer takes the Add tap itself", e.g. custom-patch; added 2026-10-18 for the patch
  // retargeting ad): the drawer takes the Add tap first (window capture, before the app) and adds the same form, its
  // properties[...] fields included, so the drawer opens instead of /cart. With the name (or any required field) empty
  // it steps aside and the app runs its own check, as today.
  var ownAdd = (',' + (el.dataset.ownAdd || '').replace(/\s/g, '') + ',').indexOf(',' + (el.dataset.productHandle || '-') + ',') > -1;
  window.addEventListener('click', function (e) {
    if (!ownAdd || !active()) return;
    var b = e.target && e.target.closest && e.target.closest('product-form-component [type="submit"]');
    var form = b && b.closest('form');
    if (!form || b.disabled) return;
    var missing = Array.prototype.some.call(form.querySelectorAll('[name^="properties["]'), function (i) {
      return (i.required || /Which text or name/.test(i.name)) && !String(i.value || '').trim();
    });
    if (missing) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(form), v = fd.get('id');
    if (!v) { toCart('own_add_no_variant'); return; }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    var q = Math.max(1, Number(fd.get('quantity') || 1)), extra = pppItems().concat(extraItems(form));
    setBusy(b, true); emit('own_add', { variant: Number(v) });
    getCart().then(function (c) {
      var before = units(c, v);
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'add failed'); return j; }); })
        .then(function () { return addPpp(extra); })
        .then(function () { return afterAdd(v, before + q, b, 'own_add'); });
    }).catch(function (err) { setBusy(b, false); emit('error', { message: 'own add: ' + String(err && err.message || '').slice(0, 80) }); toCart('own_add_error'); });
  }, true);

  // landers (native product forms): runs after the form's own listeners; a guard that stopped the submit wins
  document.addEventListener('submit', function (e) {
    if (!active() || e.defaultPrevented) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.closest('product-form-component') || form.closest('#Tk9Cart') || (form.classList && form.classList.contains('sticky-add-to-cart__form'))) return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add\/?$/.test(action)) return;
    var v = formVariant(form); if (!v) return;
    e.preventDefault();
    var fd;
    try { fd = e.submitter ? new FormData(form, e.submitter) : new FormData(form); } catch (x) { fd = new FormData(form); }
    var btn = e.submitter || form.querySelector('[type="submit"]'), q = Math.max(1, Number(fd.get('quantity') || 1)), extra = extraItems(form);
    setBusy(btn, true);
    var native = function (why) { setBusy(btn, false); emit('fallback', { reason: why }); HTMLFormElement.prototype.submit.call(form); };
    getCart().then(function (c) {
      var before = units(c, v);
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'add failed'); return j; }); })
        .then(function () { return addPpp(extra); })
        .then(function () { return afterAdd(v, before + q, btn, 'lander'); });
    }).catch(function (err) { native(String(err && err.message || 'add failed').slice(0, 80)); });
  });

  /* ---------------- impressions ---------------- */
  var io = null;
  function seen() {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    var root = el.querySelector('[data-kcd-scroll]');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || !opened) return;
        var r = e.target, wid = r.getAttribute('data-watch-component');
        if (wid && !wSeen[wid]) { wSeen[wid] = 1; wt(r, 'open'); }
        var id = 'kcd_seen_' + (r.dataset.kcdOffer || r.dataset.rule || 'nudge') + ':' + (r.dataset.rank || '');
        try { if (sessionStorage.getItem(id)) return; sessionStorage.setItem(id, '1'); } catch (x) {}
        emit('impression', info(r));
        io.unobserve(r);
      });
    }, { root: root, threshold: 0.5 });
    el.querySelectorAll('[data-kcd-offer]:not([data-key]), .kcd-nudge:not([hidden])').forEach(function (r) { io.observe(r); });
  }
  function info(r) {
    return { offer_id: r.dataset.kcdOffer || ('nudge:' + (r.dataset.rule || r.dataset.kind || '')), lane: r.dataset.lane || 'line', rank: Number(r.dataset.rank || 0), variant: Number(r.dataset.variant || 0), price: Number(r.dataset.price || 0) / 100 };
  }

  /* ---------------- drawer actions ---------------- */
  function run(p, done) {
    if (busy) return;
    busy = true; el.classList.add('is-busy'); msg('');
    // any action after the add: the "Added" note has done its job
    p.then(function (j) { showAdded(''); paint(j); if (j && j.kcdMsg) msg(j.kcdMsg); if (done) done(j); })
      .catch(function (e) {
        // the message is shown AFTER the redraw (a redraw replaces the message line; before 2026-10-18 every error
        // message was wiped this way). Shopify's stock replies ("Only 195 items were added ... due to availability",
        // "The maximum quantity of this item is already in your cart") become one plain sentence.
        var m = String(e && e.message || '');
        var text = /availability|maximum quantity|sold out|not enough/i.test(m) ? 'That’s all we have of this option right now.' : (m && m !== 'cart error' ? m : 'That didn’t work. Please try again.');
        emit('error', { message: m.slice(0, 120) });
        return refresh().catch(function () {}).then(function () { msg(text); });
      })
      .then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  function toggle(r) {
    var d = info(r);
    if (!r.dataset.textProp || r.dataset.key || (r.querySelector('[data-kcd-text]') || {}).value) { wt(r, r.dataset.key ? 'change' : 'click'); if (!r.dataset.key) wroot('change'); }
    if (r.dataset.key) {
      run(post('/cart/change.js', { id: r.dataset.key, quantity: 0 }), function () { emit(d.lane === 'protect' ? 'protect_remove' : 'offer_remove', d); });
      return;
    }
    var props = { _tk9_upsell: 'drawer:' + d.offer_id + ':' + d.rank };
    if (r.dataset.textProp) {
      var input = r.querySelector('[data-kcd-text]'), val = input ? input.value.trim() : '';
      if (!val) { r.classList.add('is-missing'); msg('Type the name to print, then tap the patches again.'); if (input) input.focus(); return; }
      props[r.dataset.textProp] = val;
      var i2 = r.querySelector('[data-kcd-text2]'), v2 = i2 ? i2.value.trim() : '';
      if (r.dataset.text2Prop && v2) props[r.dataset.text2Prop] = v2;
      // custom name patches: the same mockup and source fields the /cart upsell writes (tk9-icu-native-upsell.js), so the
      // abandoned-cart mockup, production and reporting read a drawer patch exactly like a /cart patch
      if (r.dataset.textProp === 'Which text or name you want printed') {
        props._tk9_patch_mockup_format = 'svg_v4_pair_cart_single_preview';
        props._tk9_patch_mockup_line_1 = val;
        props._tk9_patch_mockup_line_2 = v2;
        props._tk9_custom_patch_source = 'cart';
        props._tk9_custom_patch_label = 'Cart';
        props._tk9_custom_patch_surface = 'tk9_cart_drawer';
        props._tk9_custom_patch_source_label = 'Cart';
        props._tk9_custom_patch_source_surface = 'tk9_cart_drawer';
      }
    }
    run(post('/cart/add.js', { items: [{ id: d.variant, quantity: 1, properties: props }] }), function () { emit(d.lane === 'protect' ? 'protect_add' : 'offer_add', d); });
  }

  // Liquid prints line properties as [[name, value], ...]; the cart API wants an object
  function lineProps(line) {
    var raw = null, p = {};
    try { raw = JSON.parse(line.dataset.props || '{}'); } catch (e) { raw = null; }
    if (Array.isArray(raw)) raw.forEach(function (kv) { if (Array.isArray(kv) && kv.length > 1) p[kv[0]] = kv[1]; });
    else if (raw && typeof raw === 'object') p = raw;
    return p;
  }
  function dealProps(line, bid) {
    var p = lineProps(line);
    p.__kaching_bundles = JSON.stringify({ deal: line.dataset.deal, pp: Number(line.dataset.pp), main: true, bid: bid });
    return p;
  }
  // Buy 2 / Buy 3: the cart must then charge what the button said, else the line goes back to how it was
  function qtyDeal(line, q, bid, expect, kind) {
    var variant = Number(line.dataset.variant), oldQ = Number(line.dataset.qty), oldProps = lineProps(line);
    var d = { product: Number(line.dataset.pp), variant: variant, qty: q, expect: expect / 100, kind: kind };
    var body = { id: line.dataset.key, quantity: q };
    if (kind === 'kaching') body.properties = dealProps(line, bid);
    run(post('/cart/change.js', body).then(function (j) {
      // Shopify may split a discounted quantity into several lines ($59.99 + $39.01): judge the variant's lines together
      var lines = (j.items || []).filter(function (x) { return x.variant_id === variant && (kind !== 'kaching' || String((x.properties || {}).__kaching_bundles || '').indexOf(bid) > -1); });
      var got = 0, charged = 0;
      lines.forEach(function (x) { got += x.quantity; charged += x.final_line_price; });
      d.charged = charged / 100;
      if (lines.length && got === q && charged <= expect + q) { emit('qty_deal_add', d); return j; }
      emit('qty_deal_fail', d);
      if (!lines.length) return j;
      var back = kind === 'kaching' && lines.length === 1 ? post('/cart/change.js', { id: lines[0].key, quantity: oldQ, properties: oldProps }) : post('/cart/update.js', { updates: (function () { var u = {}; u[variant] = oldQ; return u; })() });
      return back.then(function (j2) { j2.kcdMsg = 'That deal didn’t apply, so your cart is unchanged.'; return j2; });
    }));
  }
  // variant swap (bigger pack, model upgrade): add the target with the line's own properties, then take the source
  // line down by the same quantity; if that fails the target comes back out. The line keeps _tk9_lander and any
  // patch, mockup or attribution property.
  function swap(line, target, rule) {
    var srcKey = line.dataset.key, srcVariant = Number(line.dataset.variant), q = Number(line.dataset.qty) || 1;
    var props = lineProps(line); props._tk9_upsell = 'drawer:' + rule + ':1'; props._tk9_upgrade_from_variant = String(srcVariant);
    var d = { rule: rule, from: srcVariant, to: Number(target), qty: q };
    run(getCart().then(function (c0) {
      var t0 = units(c0, target);
      return post('/cart/add.js', { items: [{ id: Number(target), quantity: q, properties: props }] }).then(function () {
        return getCart();
      }).then(function (c1) {
        var src = (c1.items || []).filter(function (i) { return i.key === srcKey || (i.variant_id === srcVariant && i.quantity >= q); })[0];
        if (!src || units(c1, target) < t0 + q) throw new Error('swap check');
        return post('/cart/change.js', { id: src.key, quantity: Math.max(0, src.quantity - q) });
      }).then(function (j) { emit('swap_add', d); return j; }).catch(function (err) {
        emit('swap_fail', d);
        return getCart().then(function (c2) {
          var added = (c2.items || []).filter(function (i) { return i.variant_id === Number(target) && (i.properties || {})._tk9_upgrade_from_variant === String(srcVariant); })[0];
          var stillSrc = (c2.items || []).some(function (i) { return i.variant_id === srcVariant; });
          if (added && stillSrc) return post('/cart/change.js', { id: added.key, quantity: Math.max(0, added.quantity - q) });
          return post('/cart/update.js', {});
        }).then(function (j2) { j2.kcdMsg = 'That upgrade didn’t go through, so your cart is unchanged.'; return j2; });
      });
    }));
  }
  // 2MBH -> 4MBH: Liquid only sees a product's first 250 variants, so the target is found here from the product JSON
  var pjCache = {};
  function productJson(handle) {
    if (!pjCache[handle]) pjCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    return pjCache[handle];
  }
  // the full source -> target map (assets/tk9-cart-upgrades.json, built from the Admin API by tools/build-upgrade-map.mjs):
  // the storefront product JSON stops at 250 variants, which left MultiCam and Olive Drab Green classic lines (30% of
  // classic sales) without an upgrade until 2026-10-18. The product JSON is the fallback (and the only source outside USD,
  // since the map's prices are dollars).
  var upmapP = null;
  function upgradeMap() { if (!upmapP) upmapP = fetch(el.dataset.upmap, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); return upmapP; }
  function upgradeTarget(b, src) {
    var usd = ((inner() && inner().dataset.currency) || 'USD') === 'USD';
    return (usd && el.dataset.upmap ? upgradeMap() : Promise.resolve({})).then(function (m) {
      var hit = null;
      Object.keys(m || {}).forEach(function (k) { var e = m[k]; if (e && e.target === b.dataset.kcdUpgrade && e.map && e.map[src]) hit = e.map[src]; });
      if (hit) return { id: hit[0], price: hit[1] };
      return productJson(b.dataset.kcdUpgrade).then(function (p) {
        var x = (p.variants || []).filter(function (x) { return x.available && x.option1 === b.dataset.o1 && String(x.option2 || '').split(' (')[0] === b.dataset.o2 && (x.option3 || '') === b.dataset.o3; })[0];
        return x ? { id: x.id, price: x.price } : null;
      });
    });
  }
  function upgrades() {
    el.querySelectorAll('[data-kcd-upgrade]').forEach(function (b) {
      var line = b.closest('[data-key]'), from = Number(line.dataset.price || 0);
      upgradeTarget(b, String(line.dataset.variant)).then(function (t) {
        if (!t || !b.isConnected) return;
        var delta = t.price - from;
        if (delta < 0) return;
        b.dataset.target = t.id; b.dataset.expect = t.price;
        var dl = b.querySelector('[data-kcd-up-delta]'); if (dl) dl.textContent = delta > 0 ? '+' + money(delta) : 'same price';
        b.hidden = false;
        if (io) io.observe(b);
      }).catch(function () {});
    });
  }

  el.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-kcd-close]')) { e.preventDefault(); close(); return; }
    var tg = t.closest('[data-kcd-toggle]');
    if (tg) { e.preventDefault(); toggle(tg.closest('[data-kcd-offer]') || tg); return; }
    var dn = t.closest('[data-kcd-deal]');
    if (dn) { wt(dn, 'click'); wroot('change'); qtyDeal(dn.closest('[data-key]'), Number(dn.dataset.kcdDeal), dn.dataset.bid, Number(dn.dataset.expect), dn.dataset.kind); return; }
    var sw = t.closest('[data-kcd-swap]');
    if (sw) { wt(sw, 'click'); wroot('change'); swap(sw.closest('[data-key]'), sw.dataset.kcdSwap, 'step'); return; }
    var up = t.closest('[data-kcd-upgrade]');
    if (up && up.dataset.target) { wt(up, 'click'); wroot('change'); swap(up.closest('[data-key]'), up.dataset.target, 'upgrade'); return; }
    var q = t.closest('[data-kcd-qty]');
    if (q) {
      var line = q.closest('[data-key]'), nq = Number(q.dataset.kcdQty), body = { id: line.dataset.key, quantity: nq };
      if (nq === 0) { try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: 'cart_remove', action: 'click', component_id: 'tk9.cart.line.remove' }); } catch (e) {} }
      else wt(line, 'change');
      // a Kaching deal line keeps the bid that matches its new quantity (1-3), so the deal follows the stepper
      var bids = (line.dataset.bids || '').split(',');
      if (line.dataset.deal && nq >= 1 && nq <= 3 && bids[nq - 1]) body.properties = dealProps(line, bids[nq - 1]);
      // an option that stops at 0 (e.g. doggles Medium): Shopify keeps the quantity it has; say so instead of a silent tap
      var change = post('/cart/change.js', body).then(function (j) {
        if (nq > 0 && !body.properties) { var it = (j.items || []).filter(function (i) { return i.key === line.dataset.key; })[0]; if (it && it.quantity < nq) j.kcdMsg = 'Only ' + it.quantity + ' left in this option.'; }
        return j;
      });
      run(change, function () { emit(nq === 0 ? 'line_remove' : 'line_qty', { qty: nq, variant: Number(line.dataset.variant) }); });
      return;
    }
    var sk = t.closest('[data-kcd-skip]');
    if (sk) {
      wt(sk, 'click');
      var cur = (inner() && inner().dataset.skip) || '';
      run(post('/cart/update.js', { attributes: { _tk9_skip: (cur ? cur + ',' : '') + sk.dataset.kcdSkip } }), function () { emit('offer_skip', { hero: sk.dataset.kcdSkip }); });
      return;
    }
    if (t.closest('[data-kcd-link]')) { wt(t.closest('[data-kcd-offer]'), 'click'); emit('offer_link', info(t.closest('[data-kcd-offer]'))); return; }
    if (t.closest('[data-kcd-checkout]')) {
      wt(t.closest('[data-kcd-checkout]'), 'click'); wroot('complete'); var i = inner(); emit('checkout_click', { items: Number(i.dataset.count || 0), value: Number(i.dataset.total || 0) / 100 });
      // Watch also flags this visit itself: its recorder marks checkout_clicked on pointerdown of any name="checkout" button
    }
  });
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Enter' && e.target.matches('[data-kcd-text],[data-kcd-text2]')) { e.preventDefault(); toggle(e.target.closest('[data-kcd-offer]')); }
  });
  el.addEventListener('input', function (e) { var r = e.target.closest && e.target.closest('.is-missing'); if (r) { r.classList.remove('is-missing'); msg(''); } });

  // Candy Rack's popup skips add buttons with class cr-ignore. Window capture runs before its document-level click
  // listener, so the clicked button is marked just in time even if the theme re-rendered it (drawer arm only).
  var ADD_BTN = 'form[action*="/cart/add"] [type="submit"], [data-tkd-add], [data-tkd-submit], .candy-cloned';
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(ADD_BTN);
    if (!b || b.closest('#Tk9Cart')) return;
    // holdout (today's flow): the cart gets _tk9_arm=holdout now, so Candy Rack's later add lands on a tagged cart
    if (!killed && arm === 'holdout') { writeArm(); return; }
    if (active()) b.classList.add('cr-ignore');
  }, true);

  // the header cart icon opens the drawer (not on /cart itself)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.action__cart, a[href="/cart"].header-actions__action');
    if (!a || !active() || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open({ source: 'icon' });
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted && opened) refresh().catch(function () {}); });

  function setMode() {
    var h = document.documentElement;
    if (active()) { h.dataset.cartType = 'drawer'; h.classList.add('tk9c-on'); document.querySelectorAll(ADD_BTN).forEach(function (b) { if (!b.closest('#Tk9Cart')) b.classList.add('cr-ignore'); }); }
    else { if (h.dataset.cartType === 'drawer') delete h.dataset.cartType; h.classList.remove('tk9c-on'); }
  }
  setMode();

  window.TK9Cart = {
    version: V, arm: arm,
    active: active,
    open: open, close: close, refresh: function () { return refresh(); },
    early: function () { earlyAdd(); },
    disable: function () { store.set('tk9_cart_off', '1'); killed = true; setMode(); close(); emit('kill_switch', { on: false }); },
    enable: function () { store.set('tk9_cart_off', null); killed = el.dataset.enabled !== 'true' || el.dataset.scope === 'false'; setMode(); emit('kill_switch', { on: !killed }); }
  };
  // an Add that landed before this script loaded (see earlyAdd)
  if (window.__tk9Early) earlyAdd();
  if (killed && store.get('tk9_cart_off') === '1') emit('kill_switch', { on: false, via: 'stored' });
})();
